import { assert_number_gte_0, assert_type_string, not_implemented } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';

export abstract class DTODiffusionModelsTablePageSettingsBase extends DTO__base {
  /*
   * STATIC METHODS
   */

  static round_down_to_nearest_index(row_index: number) {
    let { DIFFUSION_MODELS_TABLE_PAGE_ITEMS_AMOUNT } = CONSTANTS__shared;

    return Math.floor(row_index / DIFFUSION_MODELS_TABLE_PAGE_ITEMS_AMOUNT) * DIFFUSION_MODELS_TABLE_PAGE_ITEMS_AMOUNT;
  }

  static index_row_to_index_page(row_index: number) {
    let { DIFFUSION_MODELS_TABLE_PAGE_ITEMS_AMOUNT } = CONSTANTS__shared;

    return Math.floor(row_index / DIFFUSION_MODELS_TABLE_PAGE_ITEMS_AMOUNT);
  }

  /*
   * FIELDS
   */
  //"" = all
  filter_type!: string;
  /*
   * FIELDS IGNORED IN HASH
   */
  index_page!: number;

  /*
   * METHODS
   */

  assert_standard_fields() {
    assert_type_string(this.filter_type);
    assert_number_gte_0(this.index_page);
  }

  is_filter_type_all() {
    return this.filter_type == '';
  }

  get_hash_crc32_table() {
    not_implemented();
  }
}
